/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ShowField_data = {
    readonly label: string | null;
    readonly value: ReadonlyArray<{
        readonly key: string;
        readonly " $fragmentRefs": FragmentRefs<"SemanticString_data">;
    }> | null;
    readonly " $refType": "ShowField_data";
};
export type ShowField_data$data = ShowField_data;
export type ShowField_data$key = {
    readonly " $data"?: ShowField_data$data;
    readonly " $fragmentRefs": FragmentRefs<"ShowField_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShowField_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SemanticString",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SemanticString_data"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ShowField",
  "abstractKey": null
};
(node as any).hash = '1fe8defe147eee7e030888561ac4ae48';
export default node;
